import { POLLS_RESPONSE_COLLECTION } from "../../../../AppConstants/CollectionConstants";
import { DESCENDING, TIMESTAMP } from "../../../../AppConstants/SortConstants";

import firebase, { firestore } from "../../../../firebase/firebase";

const getUserResponse = async (userId, pollId) => {
  return new Promise(async (res, rej) => {
    try {
      const ref = firestore
        .collection(POLLS_RESPONSE_COLLECTION)
        .doc(`${userId}+${pollId}`);
      const doc = await ref.get();
      if (doc.exists) {
        res(doc.data().option);
      } else {
        res(null);
      }
    } catch (error) {
      rej(error);
    }
  });
};

const getPollResponses = async (pollId) => {
  try {
    let docRef = firestore
      .collection(POLLS_RESPONSE_COLLECTION)
      .where("pollId", "==", pollId);
    docRef = docRef.orderBy(TIMESTAMP, DESCENDING);

    const query = await docRef.get();
    if (query.empty) {
      return [];
    }

    let _data = [];
    query.docs.forEach((doc) => {
      _data.push(doc.data());
    });

    return _data;
  } catch (error) {
    console.log("Error :: ", error);
    throw error;
  }
};

const get = {
  getUserResponse,
  getPollResponses,
};

export default get;
